import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import compose from 'ramda/es/compose';

import messages from './skipNavigationButton.messages';
import { SkipNavigation } from './skipNavigationButton.styles';


export class SkipNavigationButtonComponent extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    intl: PropTypes.object,
  };

  handleOnClick = () => {
    const mainContent = document.querySelector('main');

    if (mainContent) {
      mainContent.focus();
    }
  };

  render = () => {
    const { className, intl } = this.props;

    return (
      <SkipNavigation
        className={className}
        aria-label={intl.formatMessage(messages.buttonLabel)}
        onClick={this.handleOnClick}
      >
        <FormattedMessage {...messages.buttonLabel} />
      </SkipNavigation>
    );
  };
}

export const SkipNavigationButton = compose(
  injectIntl,
)(SkipNavigationButtonComponent);
